import styled from '@emotion/styled';

export const FooterContainer = styled.div`
    height: 64px;
    width: 100%;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    border-top: 1px solid #8c8c8c;
    background-color: #ffffff;
`;
